<br />
<div class="row">
  <div class="col-md-11 offset-md-1 text-left  col-12">
    <h1 class="title">
      <span>VIEW ABSTRACT LIST: <strong>{{activeProjectTitle}}</strong></span>
    </h1>
  </div>
</div>
<div class="row">
  <div class="col-md-1"></div>
  <div class="col-md-11 col-12">

    <!-- View Abstract Mode: Begin -->

    <div class="filter-row">
      <div class="filters-left">
        <!--<div>
          <h6>Coding Protocol</h6>
          <mat-form-field style="width:250px !important;">
            <mat-select matNativeControl #matSelectProtocol [(value)]="protocolSelected" title="Protocol" required>
              <mat-option *ngFor="let protocol of protocols" [value]="protocol.id"
                (click)="selectProtocol(protocol)">{{protocol.title}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->
        <div>
          <h6>Filters List</h6>
          <mat-form-field style="width:380px !important;">
            <mat-select matNativeControl #matSelectFilter [(value)]="filterOptionSelected" title="Filters list" required>
              <mat-option *ngFor="let option of filteroptions" [value]="option.name"
                (click)="filterSelected(option)">{{option.displayText}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="actionoptions.length>0">
          <div>
            <h6>Actions List</h6>
            <div class="row">
              <mat-form-field>
                <mat-select matNativeControl required [(value)]="actionOptionSelected"
                  (selectionChange)="actionChange($event.value)">
                  <mat-option *ngFor="let option of actionoptions" [value]="option.name">{{option.displayText}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <button mat-button class="btn btn-success submit-btn"
            *ngIf="actionOptionSelected!='' && actionOptionSelected!='selectaction' && selection.selected.length >0"
            (click)="submitAction()">
            Submit
          </button>
        </ng-container>
      </div>
      
      <div class="text-right filters-right">
        <h6>Search</h6>
        <mat-form-field class="example-form-field form-field-full-width">
          <input matInput id="searchInput" type="text" title="search box" [(ngModel)]="searchTerm"
            (keyup)="searchTermChange($event)">
          <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchTerm()">
            <mat-icon><b>x</b></mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <!-- View Abstract Mode: End -->

    <div class="filter-row" style="padding-bottom: 5px;">
      <div>
        <!--<mat-checkbox id="filterByProtocol" [(ngModel)]="filterByProtocol"
          (change)="filterByProtocolChange($event)" color="primary" >
          <h6 style="margin-bottom:0;">Restrict List to Selected Coding Protocol</h6>
        </mat-checkbox>-->
        <h6>
          Columns A, B, C, D, E, F, X show Kappa 1 scores: QC Coder Average
        </h6>
      </div>
      <div class="pull-right" *ngIf="showPaginator">
        <mat-paginator class="clear-paginator" #paginatorTop [length]="abstractsData.abstractCount" [pageSize]="pageSize"
                       [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" [showFirstLastButtons]="true" [pageIndex]="pageIndex"
                       (page)="pageIndex = $event.pageIndex;  pageSize  = $event.pageSize ">
        </mat-paginator>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="example-container mat-elevation-z8">
          <div class="example-loading-shade" *ngIf="isLoadingResults">
            <!-- <mat-spinner *ngIf="isLoadingResults"></mat-spinner>-->
          </div>
          <div class="example-table-container">
            <div class="row">
              <ag-grid-angular style="width: 100%;"
                               [rowData]="abstractsData.abstractResult"
                               [columnDefs]="colDefs"
                               [defaultColDef]="defaultColDef"
                               [gridOptions]="gridOptions"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-5 offset-md-7 pull-right" *ngIf="showPaginator">
        <mat-paginator class="clear-paginator" #paginatorBottom [length]="abstractsData.abstractCount" [pageSize]="pageSize"
                       [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" [showFirstLastButtons]="true" [pageIndex]="pageIndex"
                       (page)="pageIndex = $event.pageIndex; pageSize = $event.pageSize">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
